import { FASTMenuItem as a, menuItemTemplate as i } from "@matrix42/fast-foundation";
import { menuItemStyles as l } from "./menu-item.styles.js";
import { slotBehavior as n } from "../../common/behaviors/slot-behavior.js";
const e = class e extends a {
  constructor() {
    super(...arguments), this._slotBehavior = n(() => {
      var o, s;
      const t = (o = this.shadowRoot) == null ? void 0 : o.querySelectorAll(".content")[0];
      t == null || t.setAttribute("data-text", (s = this.textContent) == null ? void 0 : s.trim());
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.$fastController.addBehavior(this._slotBehavior);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.$fastController.removeBehavior(this._slotBehavior);
  }
};
e.definition = {
  name: "menu-item",
  template: () => i(),
  styles: l
};
let r = e;
export {
  r as MenuItem
};
